import { JwtVerifiedCredentialFormatEnum } from '@dynamic-labs/sdk-api-core';

import { getDefaultClient } from '../../../../client/defaultClient';
import { assertDefined } from '../../../../utils/assertDefined';
import type { SocialAccount, SocialProvider } from '../social.types';

/**
 * Retrieves all social accounts associated with the current user.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns An array of `SocialAccount` objects associated with the user.
 */
export const getUserSocialAccounts = (
  client = getDefaultClient()
): SocialAccount[] => {
  const { user } = client;

  assertDefined(user, 'User is not authenticated');

  const socialCredentials =
    user.verifiedCredentials.filter(
      (credential) =>
        credential.format === JwtVerifiedCredentialFormatEnum.Oauth
    ) ?? [];

  return socialCredentials.map((credential) => ({
    accountId: credential.oauthAccountId ?? undefined,
    displayName: credential.oauthDisplayName ?? undefined,
    emails: credential.oauthEmails ?? [],
    photos: credential.oauthAccountPhotos ?? [],
    provider: credential.oauthProvider as SocialProvider,
    username: credential.oauthUsername ?? undefined,
    verifiedCredentialId: credential.id,
  }));
};
